import React, { useState } from "react";
import styles from "./Row.module.sass";
import cn from "classnames";
import Checkbox from "../../../../../components/Checkbox";
import Balance,{BalanceWithChange} from "../../../../../components/Balance";
import ModalProduct from "../../../../../components/ModalProduct";
import Control from "../../Control";
import placeHolderProfile  from "../../../../../assets/images/Profile Avatar Light.svg"
import { numberWithCommas,convertSecondsToRoundedTime } from "../../../../../utils.js";

const Row = ({ item, value, onChange, up }) => {
  const [visibleActions, setVisibleActions] = useState(false);
  const [visibleModalProduct, setVisibleModalProduct] = useState(false);

  return (
    <>
      <div className={styles.row} onMouseLeave={() => setVisibleActions(false)}>
      <div className={styles.col}>
         <div className={styles.balance} style={{color:"black"}}>{item.current_rank}</div>
        </div>

        <div className={styles.col}>
        <BalanceWithChange className={styles.balance} value={item.rank_change} currentValue={item.current_rank} />
        </div>
        <div className={styles.col}>
          <div
            className={styles.item}
            // onClick={() => setVisibleModalProduct(true)}
          >
            <div className={styles.preview}>
              <img
                srcSet={`${placeHolderProfile} 2x`}
                src={placeHolderProfile}
                alt="Product"
              />
            </div>
            <div className={styles.details}>
              <div className={styles.product}>{item.full_name}</div>
              <div className={styles.wrap}>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.col}>
          <div className={styles.label}></div>
          <div className={styles.sales}>
            <div className={styles.number}>{numberWithCommas(item.current_count)}</div>
          </div>
        </div>
        <div className={styles.col}>
          <div className={styles.label}></div>
          <div className={styles.sales}>
            <div className={styles.number}>{convertSecondsToRoundedTime(item.avg_pack_time)}</div>
          </div>
        </div>
      </div>
      <ModalProduct
        visible={visibleModalProduct}
        onClose={() => setVisibleModalProduct(false)}
      />
    </>
  );
};

export default Row;
